import { render, staticRenderFns } from "./ExpirationsAndReturnOrders.vue?vue&type=template&id=209be011&scoped=true"
import script from "./ExpirationsAndReturnOrders.vue?vue&type=script&lang=js"
export * from "./ExpirationsAndReturnOrders.vue?vue&type=script&lang=js"
import style0 from "./ExpirationsAndReturnOrders.vue?vue&type=style&index=0&id=209be011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209be011",
  null
  
)

export default component.exports